import type { CSSProperties } from 'react'
import IconLoading from './assets/loading'

export default function Loading({ className, style }: { className?: string; style?: CSSProperties }) {
  return (
    <IconLoading
      className={className}
      style={{
        position: 'absolute',
        top: 13,
        left: '50%',
        zIndex: 9999, // TODO: centralize indexes
        animation: 'loading-animation 0.75s linear infinite',
        ...style,
      }}
    />
  )
}
